/**
 * SETTINGS-V2 — one studio for playbooks, MCP directory, models.
 * Decisions / credentials open as sheets. No nested hops.
 */
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { html, Ico } from "./ui.js";
import { useSession } from "./session.js";
import { AiSettingsDesk } from "./ai-settings-desk.js";
import { FabricSettingsDesk } from "./fabric-settings-desk.js";
import { AiTeamToolsNotice } from "./ai-team-tools-notice.js";
import { AiStudioDesk } from "./ai-studio-desk.js";
import { ViewportSheet } from "./viewport-sheet.js";

const ALL_TABS = [
  { id:"decisions", label:"Decisions", icon:"spark", say:"Mode, approval, thresholds." },
  { id:"models", label:"Models", icon:"layers", say:"Providers this site may use." },
  { id:"team-tools", label:"AI team tools", icon:"brain", say:"Skills and tool servers the Watch team can use. Read only." },
  { id:"credentials", label:"Credentials", icon:"lock", say:"Credential fabric. No secrets.", sa:true },
];

export default function AiAdminWorkbench({ toast }) {
  const { me } = useSession();
  const role = String((me && me.role) || "");
  const caps = Array.isArray(me && me.caps) ? me.caps : [];
  const isSa = role === "superadmin" || caps.includes("sa_full_access") || caps.includes("sa_ai_admin");
  const isUser = role === "user";
  const tabs = ALL_TABS.filter((tab) => {
    if (tab.sa && !isSa) return false;
    if (isUser) return tab.id === "team-tools";
    return true;
  });
  const [sheet, setSheet] = useState(null);

  return html`<div className="ai-admin-v2 house-rack" data-cmc-settings-ai="ai-admin-v2"
      data-cmc-ai-audience=${isUser ? "tenant-user-notice" : (isSa ? "sa-edit" : "tenant-admin")}
      data-cmc-ai-tabs=${tabs.map((t) => t.id).join(",")}>
    <h2 className="sr-only">${isUser ? "New tools for the AI team" : "Policy before automation"}</h2>
    ${isUser ? html`<${AiTeamToolsNotice} toast=${toast}/>` : null}
    <${AiStudioDesk} toast=${toast}/>
    ${!isUser ? html`<div className="ai-studio__more">
      <button type="button" className="btn btn--ghost btn--sm" onClick=${() => setSheet("decisions")}>
        <${Ico} d="spark" w=${13}/> Team rules</button>
      ${isSa ? html`<button type="button" className="btn btn--ghost btn--sm" onClick=${() => setSheet("credentials")}>
        <${Ico} d="lock" w=${13}/> Credentials</button>` : null}
    </div>` : null}
    <${AnimatePresence}>
      ${sheet === "decisions" ? html`<${ViewportSheet} title="Team rules" wide=${true} dock="right"
        onClose=${() => setSheet(null)}>
        <${AiSettingsDesk} toast=${toast}/>
      <//>` : null}
      ${sheet === "credentials" ? html`<${ViewportSheet} title="Credentials" wide=${true} dock="right"
        onClose=${() => setSheet(null)}>
        <${FabricSettingsDesk} toast=${toast}/>
      <//>` : null}
    <//>
  </div>`;
}
